import useSWRImmutable from 'swr/immutable'
import {fetcher} from '~/api'
import {camelizeResult} from '~/api/serializer'
import {useRails} from '~/react/contexts/rails'

export const usePermissions = () => {
  const {
    currentSupplier: {id: supplierId},
  } = useRails()

  return useSWRImmutable(
    `/points/api/suppliers/${supplierId}/permissions`,
    fetcher,
    {
      use: [camelizeResult],
      revalidateOnFocus: false,
    },
  )
}
